import { Object3D } from 'three';
import { Mesh } from 'three/src/objects/Mesh';

import { VolumeCalculationDataType } from '../../../react/components/skyview-new/components/report-tool-menu/helpers/types';
import { Design } from '../design';
import { Dxf } from '../dxf';
import { Geometry } from '../geometry';
import { Glb } from '../glb';
import { TerrainModel } from '../terrain-model';

/**
 * Composite type for all asset types that are possible to use as target data or source data
 * for a volume calculation.
 */
export type VolumeCalculationAsset = Geometry | Design | Dxf | TerrainModel | Glb;
export abstract class VolumeCalculationAssetTypeGuard {
  static check(asset?: Object3D): asset is VolumeCalculationAsset {
    return (
      (asset instanceof Geometry && asset.isArea) ||
      asset instanceof Design ||
      asset instanceof Dxf ||
      asset instanceof TerrainModel ||
      asset instanceof Glb
    );
  }
}

export enum VolumeState {
  Idle,
  InProgress,
  Done,
}

export enum VolumeModelState {
  Visible,
  Hidden,
  Loading,
}

export interface GeometryMesh {
  vertices: number[];
  indices: number[];
}

export interface VolumeBoundaryData {
  mesh: Mesh;
  boundaryType?: VolumeCalculationDataType;
}
